import { default as wB, __t } from '../../../shared/js/bootstrap';
// here logger is already imported and you can extract it from the wB
import { default as logger } from '../../../shared/js/modules/logger/logger.module';

if (typeof window !== 'undefined') {
  window.wB = wB;
  window.__t = __t;
}
